"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _GeometryType = _interopRequireDefault(require("./GeometryType.js"));

var _Point = _interopRequireDefault(require("./Point.js"));

var _SimpleGeometry = _interopRequireDefault(require("./SimpleGeometry.js"));

var _extent = require("../extent.js");

var _deflate = require("./flat/deflate.js");

var _array = require("../array.js");

var _inflate = require("./flat/inflate.js");

var _math = require("../math.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/geom/MultiPoint
 */


/**
 * @classdesc
 * Multi-point geometry.
 *
 * @api
 */
var MultiPoint =
/** @class */
function (_super) {
  __extends(MultiPoint, _super);
  /**
   * @param {Array<import("../coordinate.js").Coordinate>|Array<number>} coordinates Coordinates.
   *     For internal use, flat coordinates in combination with `opt_layout` are also accepted.
   * @param {import("./GeometryLayout.js").default} [opt_layout] Layout.
   */


  function MultiPoint(coordinates, opt_layout) {
    var _this = _super.call(this) || this;

    if (opt_layout && !Array.isArray(coordinates[0])) {
      _this.setFlatCoordinates(opt_layout,
      /** @type {Array<number>} */
      coordinates);
    } else {
      _this.setCoordinates(
      /** @type {Array<import("../coordinate.js").Coordinate>} */
      coordinates, opt_layout);
    }

    return _this;
  }
  /**
   * Append the passed point to this multipoint.
   * @param {Point} point Point.
   * @api
   */


  MultiPoint.prototype.appendPoint = function (point) {
    if (!this.flatCoordinates) {
      this.flatCoordinates = point.getFlatCoordinates().slice();
    } else {
      (0, _array.extend)(this.flatCoordinates, point.getFlatCoordinates());
    }

    this.changed();
  };
  /**
   * Make a complete copy of the geometry.
   * @return {!MultiPoint} Clone.
   * @api
   */


  MultiPoint.prototype.clone = function () {
    var multiPoint = new MultiPoint(this.flatCoordinates.slice(), this.layout);
    multiPoint.applyProperties(this);
    return multiPoint;
  };
  /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   */


  MultiPoint.prototype.closestPointXY = function (x, y, closestPoint, minSquaredDistance) {
    if (minSquaredDistance < (0, _extent.closestSquaredDistanceXY)(this.getExtent(), x, y)) {
      return minSquaredDistance;
    }

    var flatCoordinates = this.flatCoordinates;
    var stride = this.stride;

    for (var i = 0, ii = flatCoordinates.length; i < ii; i += stride) {
      var squaredDistance = (0, _math.squaredDistance)(x, y, flatCoordinates[i], flatCoordinates[i + 1]);

      if (squaredDistance < minSquaredDistance) {
        minSquaredDistance = squaredDistance;

        for (var j = 0; j < stride; ++j) {
          closestPoint[j] = flatCoordinates[i + j];
        }

        closestPoint.length = stride;
      }
    }

    return minSquaredDistance;
  };
  /**
   * Return the coordinates of the multipoint.
   * @return {Array<import("../coordinate.js").Coordinate>} Coordinates.
   * @api
   */


  MultiPoint.prototype.getCoordinates = function () {
    return (0, _inflate.inflateCoordinates)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
  };
  /**
   * Return the point at the specified index.
   * @param {number} index Index.
   * @return {Point} Point.
   * @api
   */


  MultiPoint.prototype.getPoint = function (index) {
    var n = !this.flatCoordinates ? 0 : this.flatCoordinates.length / this.stride;

    if (index < 0 || n <= index) {
      return null;
    }

    return new _Point["default"](this.flatCoordinates.slice(index * this.stride, (index + 1) * this.stride), this.layout);
  };
  /**
   * Return the points of this multipoint.
   * @return {Array<Point>} Points.
   * @api
   */


  MultiPoint.prototype.getPoints = function () {
    var flatCoordinates = this.flatCoordinates;
    var layout = this.layout;
    var stride = this.stride;
    /** @type {Array<Point>} */

    var points = [];

    for (var i = 0, ii = flatCoordinates.length; i < ii; i += stride) {
      var point = new _Point["default"](flatCoordinates.slice(i, i + stride), layout);
      points.push(point);
    }

    return points;
  };
  /**
   * Get the type of this geometry.
   * @return {import("./GeometryType.js").default} Geometry type.
   * @api
   */


  MultiPoint.prototype.getType = function () {
    return _GeometryType["default"].MULTI_POINT;
  };
  /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   */


  MultiPoint.prototype.intersectsExtent = function (extent) {
    var flatCoordinates = this.flatCoordinates;
    var stride = this.stride;

    for (var i = 0, ii = flatCoordinates.length; i < ii; i += stride) {
      var x = flatCoordinates[i];
      var y = flatCoordinates[i + 1];

      if ((0, _extent.containsXY)(extent, x, y)) {
        return true;
      }
    }

    return false;
  };
  /**
   * Set the coordinates of the multipoint.
   * @param {!Array<import("../coordinate.js").Coordinate>} coordinates Coordinates.
   * @param {import("./GeometryLayout.js").default} [opt_layout] Layout.
   * @api
   */


  MultiPoint.prototype.setCoordinates = function (coordinates, opt_layout) {
    this.setLayout(opt_layout, coordinates, 1);

    if (!this.flatCoordinates) {
      this.flatCoordinates = [];
    }

    this.flatCoordinates.length = (0, _deflate.deflateCoordinates)(this.flatCoordinates, 0, coordinates, this.stride);
    this.changed();
  };

  return MultiPoint;
}(_SimpleGeometry["default"]);

var _default = MultiPoint;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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